import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { BrandProvider } from "./context/BrandContext";
import { Layout } from "./components/layout/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Track from "./pages/Track";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
import InvoicePage from "./pages/InvoicePage";
import { AuthProvider } from "./context/AuthContext";
import { AdminLayout } from "./components/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import AdminShipments from "./pages/admin/Shipments";
import ShipmentDetail from "./pages/admin/ShipmentDetail";
import Messages from "./pages/admin/Messages";
import Settings from "./pages/admin/Settings";
import Account from "./pages/admin/Account";
import Leads from "./pages/admin/Leads";
import Reviews from "./pages/admin/Reviews";
import { ChatList, ChatTranscript } from "./pages/admin/Chats";

function App() {
  return (
    <div className="App">
      <BrandProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/invoice/:token" element={<InvoicePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="shipments" element={<AdminShipments />} />
              <Route path="shipments/:tn" element={<ShipmentDetail />} />
              <Route path="messages" element={<Messages />} />
              <Route path="settings" element={<Settings />} />
              <Route path="account" element={<Account />} />
              <Route path="leads" element={<Leads />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="chats" element={<ChatList />} />
              <Route path="chats/:sid" element={<ChatTranscript />} />
            </Route>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/track" element={<Track />} />
              <Route path="/track/:trackingNumber" element={<Track />} />
              <Route path="/register" element={<Register />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </AuthProvider>
        <Toaster theme="light" position="top-center" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E2E8F0", color: "#0F172A", borderRadius: 0 } }} />
      </BrandProvider>
    </div>
  );
}

export default App;
